import { render } from "./AddNewNoteTag.vue?vue&type=template&id=818e22d4"
import script from "./AddNewNoteTag.vue?vue&type=script&lang=js"
export * from "./AddNewNoteTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__